import { isApiError } from '@/shared/api/errors/errors';

export function errorName(error: unknown): string {
  return error instanceof Error ? error.name : 'Error';
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error ?? 'Unknown error');
}

export function errorStack(error: unknown): string | undefined {
  return error instanceof Error ? error.stack : undefined;
}

/** `pageUrl` is passed in rather than read from `window` so this stays a pure transform. */
export function formatErrorDetails(
  error: unknown,
  componentStack: string | null | undefined,
  pageUrl: string
): string {
  const lines: string[] = [`${errorName(error)}: ${errorMessage(error)}`];

  if (isApiError(error)) {
    lines.push(`Code: ${error.code}`, `Status: ${error.status}`);
    if (error.traceId) lines.push(`Trace ID: ${error.traceId}`);
    if (error.requestUrl) {
      lines.push(`Request: ${[error.requestMethod, error.requestUrl].filter(Boolean).join(' ')}`);
    }
    if (error.errors && Object.keys(error.errors).length > 0) {
      lines.push('', 'Field errors:');
      for (const [field, messages] of Object.entries(error.errors)) {
        lines.push(`  ${field}: ${messages.join('; ')}`);
      }
    }
    if (error.cargoIndices && Object.keys(error.cargoIndices).length > 0) {
      lines.push('', 'Cargo indices:');
      for (const [key, index] of Object.entries(error.cargoIndices)) {
        lines.push(`  ${key}: ${index}`);
      }
    }
  }

  lines.push(`Page: ${pageUrl}`);

  const stack = errorStack(error);
  if (stack) lines.push('', 'Stack trace:', stack);
  if (componentStack) lines.push('', 'Component stack:', componentStack.trim());

  return lines.join('\n');
}
